// frontend/src/hooks/useTransportPortalAccess.js
import { useQuery } from '@tanstack/react-query';
import { staffAPI } from '../services/api';

/**
 * Transport-owned portal permissions, resolved through the HR backend proxy.
 */
export const useTransportPortalAccess = (options = {}) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: ['transport', 'portal-access'],
    queryFn: async () => {
      const response = await staffAPI.getTransportPortalAccess();
      return response.data;
    },
    enabled,
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });
};

export default useTransportPortalAccess;
